import React, {  useState } from 'react'
import Predictorform from '../Collegepredictor/Predictorform';
const Collegeperdictorfrom = () => {

  const [show, setShow] = useState(false);
  const handleform = () => { setShow(!show) }


  return (
    <>
      <section className='predict_your_college'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='pre_btn'>
                <button type="button" onClick={() => handleform()} class="btn btn-primary"  >
                  Predit Now
                </button>
              </div>
              {show ? (
                <div class="bg-black">
                  {/* body */}
                 <Predictorform handleform={handleform} />
                </div>

              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
export default Collegeperdictorfrom
